import app from '../../admin/app';
import SettingsModal from './SettingsModal';
export default class EditCustomCssModal extends SettingsModal {
  oninit(vnode) {
    super.oninit(vnode);
    if (this.setting('custom_less_error')()) {
      this.alertAttrs = {
        type: 'error',
        content: this.setting('custom_less_error')()
      };
    }
  }
  className() {
    return 'EditCustomCssModal TextareaCodeModal Modal--large';
  }
  title() {
    return app.translator.trans('core.admin.edit_css.title');
  }
  form() {
    return [m("p", null, app.translator.trans('core.admin.edit_css.customize_text', {
      a: m("a", {
        href: "https://github.com/flarum/core/tree/master/less",
        target: "_blank"
      })
    })), m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      rows: "30",
      bidi: this.setting('custom_less'),
      spellcheck: false
    }))];
  }
  onsaved() {
    window.location.reload();
  }
}
flarum.reg.add('core', 'admin/components/EditCustomCssModal', EditCustomCssModal);